import { IIssueBoardApi } from "@mcapps/shared";
import React from "react";
import { FailedAlert } from "../../../../components";
import { IssueDisabledColumnsEnum } from "@mcapps/shared/enums";
import { usePutProjectByProjectIdIssueboardAndBoardIdDisabledColumnsMutation } from "../../../../../openapi";
import DisabledIssueColumns from "./DisableIssueColumns";
import SettingsCardWrapper from "./SettingsCardWrapper";

const IssueColumnSettings: React.FC<{ issueBoard: IIssueBoardApi }> = ({ issueBoard }) => {
  const [updateBoards, { isLoading: updateBoardsLoading, error: updateBoardsError }] =
    usePutProjectByProjectIdIssueboardAndBoardIdDisabledColumnsMutation();

  const [editMode, setEditMode] = React.useState(false);

  const columnsTobeDisabled: IssueDisabledColumnsEnum[] = [
    IssueDisabledColumnsEnum.CONNECTEDBIMSPACES,
    IssueDisabledColumnsEnum.REFERENCEURL,
    IssueDisabledColumnsEnum.PNS,
    IssueDisabledColumnsEnum.TYPEOFISSUE,
    IssueDisabledColumnsEnum.BUCKET,
    IssueDisabledColumnsEnum.DATESPLANNEDSTART,
    IssueDisabledColumnsEnum.DATESDUE,
    IssueDisabledColumnsEnum.HOURSORIGINALESTIMATE,
    IssueDisabledColumnsEnum.HOURSCOMPLETED,
    IssueDisabledColumnsEnum.HOURSREMAINING,
    IssueDisabledColumnsEnum.PRIORITY,
    IssueDisabledColumnsEnum.STATUS,
    IssueDisabledColumnsEnum.ITEMMEMBERS,
    IssueDisabledColumnsEnum.OWNER,
    IssueDisabledColumnsEnum.ASSIGNEDTO,
    IssueDisabledColumnsEnum.CONCLUSION,
    IssueDisabledColumnsEnum.DESCRIPTION,
  ];

  return (
    <SettingsCardWrapper title="Deaktiverte kolonner">
      {updateBoardsError != null && <FailedAlert />}
      <DisabledIssueColumns
        updateBoards={(disabledColumns) =>
          updateBoards({
            projectId: issueBoard.project,
            boardId: issueBoard._id,
            body: {
              disabledColumns: disabledColumns,
            },
          })
        }
        board={issueBoard}
        isEditable
        editMode={editMode}
        editCb={(bool) => setEditMode(bool)}
        columnsTobeDisabled={columnsTobeDisabled}
      />
    </SettingsCardWrapper>
  );
};

export default IssueColumnSettings;
